import React, { ReactNode, CSSProperties } from 'react';

export interface GradientTextProps {
  children: ReactNode;
  style?: CSSProperties;
  gradient?: string;
}

export const GradientText: React.FC<GradientTextProps> = ({
  children,
  style = {},
  gradient = 'linear-gradient(90deg, #1e6ef6 0%, #1449e8 100%)',  // Figma blue gradient
}) => {
  const gradientStyle: CSSProperties & {
    WebkitBackgroundClip?: string;
    WebkitTextFillColor?: string;
  } = {
    background: gradient,
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    ...style,
  };

  return (
    <span style={gradientStyle}>
      {children}
    </span>
  );
};
